<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h2 class="titulo">{{ title }}</h2>
      </div>
      <div class="col-md-6">
        <div class="peca_musica" id="contato">
          <form>
            <div class="row errorContent" v-show="checkShowErrorMessage()">
              <div class="col col-md-12">
                <div v-html="errorMessage"></div>
              </div>
            </div>
            <div class="row successContent" v-show="checkShowSuccessMessage()">
              <div class="col col-md-12">
                <div v-html="successMessage"></div>
              </div>
            </div>
            <label>
              Nome:
              <input type="text" v-model="name">
            </label>
            <label>
              Email:
              <input type="text" v-model="email">
            </label>
            <label>
              Estado:
              <select name="estados-brasil" v-model="state">
                <option value="" selected disabled>Selecione ...</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </label>
            <label>
              Cidade:
              <input type="text" v-model="city">
            </label>
            <label class="mensagem">
              Mensagem:
              <textarea v-model="message"></textarea>
            </label>

            <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
            </vue-recaptcha>

            <button class="btn_enviar" type="button" @click="callback()"> Enviar</button>

          </form>
        </div>
      </div>
      <div class="col-md-6" id="contato_redes">
        <loading v-if="! showContent"></loading>
        <h3 v-if="item.phones"><i aria-hidden="true" class="fa fa-phone"></i> {{ getPhones(item.phones) }}</h3>
        <p v-if="item.endereco" class="endereco">{{ item.endereco }}</p>
        <div class="redes_sociais" v-if="showContent">
          <a :href="social.url" v-for="social in item.socialsNetworks" v-if="social.url" target="_blank">
            <i :class="getIcon(social)" aria-hidden="true"></i>
          </a>
        </div>


      </div>
    </div>
  </div>
</template>
<style>
  .iconsContent i {
    font-size: 24px;
    margin-left: 10px;
  }
</style>
<script type="text/javascript">
  import {get, post} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import VueRecaptcha from 'vue-recaptcha';


  export default {
    components: {
      Loading,
      VueRecaptcha
    },
    data() {
      return {
        title: 'Contato',
        showContent: false,
        errorMessage: '',
        successMessage: '',
        name: '',
        email: '',
        city: '',
        state: '',
        message: '',
        item: [],
        sitekey: window.config.RECAPTCHA_KEY,
        captcha: false,
        icons: [
          {
            type: 'instagram',
            icon: 'fa-instagram'
          },
          {
            type: 'facebook',
            icon: 'fa-facebook-f'
          },
          {
            type: 'twitter',
            icon: 'fa-twitter'
          },
          {
            type: 'soundCloud',
            icon: 'fa-soundcloud'
          },
          {
            type: 'youtube',
            icon: 'fa-youtube'
          },
          {
            type: 'google',
            icon: 'fa-google-plus-g'
          },
          {
            type: 'whatsapp',
            icon: 'fa-whatsapp'
          },
          {
            type: 'blog',
            icon: 'fa-rss'
          },
          {
            type: 'flickr',
            icon: 'fa-flickr'
          },
          {
            type: 'lastfm',
            icon: 'fa-lastfm'
          },
          {
            type: 'viber',
            icon: 'fab fa-viber'
          },
          {
            type: 'skype',
            icon: 'fa-skype'
          },
          {
            type: 'snapchat',
            icon: 'fa-snapchat-ghost'
          }
        ]
      }
    },
    created() {
      let self = this;
      get('contacts-info').then(function (response) {
        self.item = response.data.result.data;
        self.showContent = true;
      })
    },
    computed: {
      existeLocale: function () {

        if (this.item.locale) {
          if (this.item.locale.lat && this.item.locale.lng) {
            return true;
          }
        }
        return false;
      }
    },
    methods: {

      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      checkShowErrorMessage() {
        return this.errorMessage !== '';
      },
      checkShowSuccessMessage() {
        return this.successMessage !== '';
      },
      clearForm() {
        this.name = '';
        this.email = '';
        this.city = '';
        this.state = '';
        this.message = '';
      },
      getIcon(item) {
        let currentIcon = '';
        this.icons.forEach(function (value) {
          if (value.type === item.type) {
            currentIcon = value.icon;
          }
        });
        return 'fab ' + currentIcon;
      },
      getPhones(phones) {
        if (typeof phones !== 'undefined' && phones !== null) {
          let stringPhones = [];
          phones.forEach(function (phone) {
            stringPhones.push(this.stringPhone(phone));
          }, this);
          return stringPhones.join(' | ');
        }
      },
      stringPhone(phone) {
        let formatted = '';
        if (phone.length === 10) {
          formatted = phone.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
        } else if (phone.length === 11) {
          formatted = phone.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
        }
        return formatted;
      },
      validate() {
        // validate your form , if you don't have validate prop , default validate pass .
        return formValid;
      },
      callback() {
        // google recaptcha token , then you can pass to backend with your form data .
        if (!this.name) {
          alert('O campo nome é obrigatório.');
          return false;
        }
        if (!this.email) {
          alert('O campo email é obrigatório.');
          return false;
        }
        if (!this.message) {
          alert('O campo message é obrigatório.');
          return false;
        }
        if (!this.captcha) {
          alert('Favor marcar captcha.');
          return false;
        }

        let self = this;
        post('contact', {
          name: this.name,
          email: this.email,
          city: this.city,
          state: this.state,
          message: this.message
        }).then(function () {
          swal({
            title: "Mensagem enviada com sucesso.",
            icon: "success",
          });
          self.clearForm();
        }).catch(function () {
          self.showContent = true;
          swal({
            title: "Ocorreu um erro ao enviar o pedido, tente novamente mais tarde.",
            icon: "error",
          });
        });

      },
    },
    watch: {
      name(name) {
        if (this.errorMessage !== '' && name.length > 0) {
          this.errorMessage = '';
        }
      },
      message(message) {
        if (this.errorMessage !== '' && message.length > 0) {
          this.errorMessage = '';
        }
      },
      email(email) {
        if (this.errorMessage !== '' && email.length > 0) {
          this.errorMessage = '';
        }
      },
      successMessage(message) {
        if (message.length > 0) {
          let self = this;
          setTimeout(function () {
            self.successMessage = '';
          }, 5000);
        }
      },
      errorMessage(message) {
        if (message.length > 0) {
          let self = this;
          setTimeout(function () {
            self.errorMessage = '';
          }, 5000);
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Contact.vue